import type { IdpUser } from '@shared-types/idp.types';

export const getTrackingData = (user: IdpUser) => {
  if (!user?.UID) {
    return {
      userLoginStatus: false,
    };
  }

  return {
    userLoginStatus: true,
    userID: user.UID,
    userNewsletterSubscriber: getIsSubscribed(user),
  };
};

export const getIsSubscribed = (user: IdpUser, newsletterId?: string) => {
  const newsletters = user?.subscriptions?.newsletters;
  if (!newsletters) return false;

  if (newsletterId) return !!newsletters[newsletterId]?.email?.isSubscribed;

  return Object.keys(newsletters).some((k) => !!newsletters[k]?.email?.isSubscribed);
};
